import React, { useState,useEffect } from 'react';

import { gql,useQuery } from '@apollo/client';
import styled from 'styled-components';
import { sendTrainingOptionEvent } from './posTrainingEvents.js';

const ResultsStack = styled.div`
  display: grid;
  gap: 8px;
`;

const OptionProduct = styled.article`
  border: 1px solid #dce3df;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
`;

const OptionProductTitle = styled.div`
  padding: 8px 10px;
  background: #f5f7f5;
  border-bottom: 1px solid #e4e9e6;
  color: #344054;
  font-size: 0.82rem;
  font-weight: 850;
  line-height: 1.25;
`;

const ItemOptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px;
`;



const SEARCH_OPTIONS = gql`
query predictiveSearch($query: String!) {
    predictiveSearch(query: $query, searchableFields: [VENDOR, TAG, VARIANTS_TITLE], types: [PRODUCT], unavailableProducts: SHOW) {
    products {
        tags  
        handle
        title
        vendor
        variants(first: 100) { 
        edges {
            node {
            title
            id
            }
        }
        }
    }
    }
}
`;

const Option = styled.button`
  min-height: 34px;
  border: 1px solid #cbd6d0;
  border-radius: 999px;
  background: #ffffff;
  color: #1f2933;
  padding: 0 10px;
  font-size: 0.84rem;
  font-weight: 800;
  cursor: pointer;
  max-width: 100%;
  overflow-wrap: anywhere;

  &:hover {
    background: #edf3f0;
  }

  &.selected {
    background-color: #1f6f5d;
    color: #ffffff;
    border-color: #1f6f5d;
  }
`;

const StatusText = styled.div`
  color: #667085;
  font-size: 0.86rem;
  font-weight: 700;
  padding: 8px 2px;
`;

function SearchResults({
    productVariantId,
    productTitle,
    searchTermWithVendorAddsSlectedOptions,
    optionSearchTerms,
    handleOptionSelected,
    selectedOptionAttributes,
    client,
    trainingSessionId,
    traineeId,
    restaurantName,
    selector,
    optionSearchStartedAt
}) {
    
    
    const [products, setProducts] = useState([]);
    
    console.log('searchTermWithVendorAddsSlectedOptions:',searchTermWithVendorAddsSlectedOptions);
    // useEffect(() => {
    //     console.log('optionSearchTerms changed:', optionSearchTerms);
    // }, [optionSearchTerms]);

    const { data, loading, error } = useQuery(SEARCH_OPTIONS, {
        variables: { query: searchTermWithVendorAddsSlectedOptions || '' },
        client: client
    });


    useEffect(() => {
        if (data && data.predictiveSearch && data.predictiveSearch.products) {
            let products = data.predictiveSearch.products;

            // Log products here
            console.log(products);
            // Filter products with tags containing specific substrings, ignoring case
            products = products.filter(product => 
                product.tags.some(tag => 
                    ["option", "less", "no", "extra", "add", 'only','Special Instruction','Sauce','On the Side'].some(filterTag => 
                        tag.toLowerCase().includes(filterTag.toLowerCase())
                    )
                )
            );
                // // Log products here
                // console.log(products);
            // Filter out the variants' titles that do not include optionSearchTerms
            products = products.map(product => {
                if (product.variants && product.variants.edges && product.variants.edges.length >= 5) {
                    return {
                        ...product,
                        variants: {
                            ...product.variants,
                            edges: product.variants.edges.filter(variant => {
                                const variantTitle = variant.node.title.toLowerCase().trim();
                                const searchTerms = optionSearchTerms.toLowerCase().trim();
                                const variantTitleWords = variantTitle.split(' ');
                                const searchTermsWords = searchTerms.split(' ');
            
                                return variantTitle.includes(searchTerms) || 
                                    searchTerms.includes(variantTitle) || 
                                    searchTermsWords.some(word => variantTitleWords.includes(word)) ||
                                    variantTitleWords.some(word => searchTermsWords.includes(word));
                            })
                        }
                    };
                } else {
                    return product;
                }
            });

            // Sort products so that products containing "On the Side" come first, ignoring case
            // products.sort((a, b) => (a.title.toLowerCase().includes("on the side") ? -1 : b.title.toLowerCase().includes("on the side") ? 1 : 0));

            setProducts(products);
            const resultCount = products.reduce((count, product) => {
                return count + (product.variants?.edges?.length || 0);
            }, 0);
            sendTrainingOptionEvent({
                eventType: 'option_results',
                searchKind: 'option',
                sessionId: trainingSessionId,
                traineeId,
                restaurantName,
                query: optionSearchTerms,
                resultCount,
                elapsedMs: optionSearchStartedAt ? Date.now() - optionSearchStartedAt : null,
                productTitle,
                productVariantId,
                selector,
            });
        }
    }, [data, optionSearchTerms, optionSearchStartedAt, productTitle, productVariantId, restaurantName, selector, traineeId, trainingSessionId]);       


    if (loading) return <StatusText>Searching requests...</StatusText>;
    if (error) return <StatusText>{error.message}</StatusText>;


    const handleOptionClick = (productVariantId,optionVariantTitle, optionVariantId, optionProductTitle) => {
      sendTrainingOptionEvent({
        eventType: 'option_selected',
        searchKind: 'option',
        sessionId: trainingSessionId,
        traineeId,
        restaurantName,
        query: optionSearchTerms,
        elapsedMs: optionSearchStartedAt ? Date.now() - optionSearchStartedAt : null,
        productTitle,
        productVariantId,
        optionProductTitle,
        optionVariantTitle,
        optionVariantId,
        selector,
      });
      // Call the callback function passed in through props
      handleOptionSelected(productVariantId, optionVariantTitle, optionVariantId, optionProductTitle);
    };
  

    



    const resultCount = products.reduce((count, product) => count + (product.variants?.edges?.length || 0), 0);

    if (!resultCount) {
      return <StatusText>No matching requests</StatusText>;
    }

    return (
      <ResultsStack>
        {products && products.map(product => {
          if (!product.variants?.edges?.length) {
            return null;
          }

          return (
            <OptionProduct key={product.handle}>
              <OptionProductTitle>{product.title}</OptionProductTitle>
              <ItemOptionsContainer>
                {product.variants.edges.map(variant => {
                  const optionVariantId = variant.node.id;
                  let optionVariantTitle = variant.node.title;
                  if (optionVariantTitle === "Default Title") {
                    optionVariantTitle = "";
                  }

                  const optionLabel = optionVariantTitle || product.title;
                  const isSelected = selectedOptionAttributes[productVariantId] && selectedOptionAttributes[productVariantId].some(option => option.optionVariantId === optionVariantId);

                  return (
                    <Option
                      key={optionVariantId}
                      type="button"
                      onClick={() => handleOptionClick(productVariantId, optionVariantTitle, optionVariantId, product.title)}
                      className={isSelected ? 'selected' : ''}
                    >
                      {optionLabel}
                    </Option>
                  )
                })}
              </ItemOptionsContainer>
            </OptionProduct>
          );
        })}
      </ResultsStack>
    );
}





export default SearchResults;
